import { useMsal } from '@azure/msal-react';
import { useCallback } from 'react';

export const useLogout = () => {
  const { instance } = useMsal();

  return useCallback(() => instance.logoutRedirect(), [instance]);
};
